import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

class PdpTechnicalSpecifications extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateSpecs);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateSpecs);
  }

  updateSpecs = (event) => {
    const newSpecs = event.detail.data.html.querySelector('pdp-technical-specifications');
    if (!newSpecs) return;
    morph(this, newSpecs, { childrenOnly: true });
  };
}

if (!customElements.get('pdp-technical-specifications')) {
  customElements.define('pdp-technical-specifications', PdpTechnicalSpecifications);
}
